import React from 'react';

export const Graph = ({ width = 140, height = 122 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 140 122"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 118.072C0 116.209 1.32436 114.699 2.95804 114.699H137.042C138.676 114.699 140 116.209 140 118.072C140 119.935 138.676 121.446 137.042 121.446H2.95804C1.32436 121.446 0 119.935 0 118.072Z"
      fill="#297FFF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.74707 78.8639C6.74707 77.229 8.05927 75.9036 9.67794 75.9036H27.4307C29.0493 75.9036 30.3615 77.229 30.3615 78.8639V116.799C30.3615 118.434 29.0493 119.759 27.4307 119.759H9.67794C8.05927 119.759 6.74707 118.434 6.74707 116.799V78.8639ZM12.6088 81.8243V113.838H24.4998V81.8243H12.6088Z"
      fill="#297FFF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M40.4814 45.1253C40.4814 43.4924 41.7936 42.1687 43.4123 42.1687H61.165C62.7837 42.1687 64.0959 43.4924 64.0959 45.1253V116.803C64.0959 118.435 62.7837 119.759 61.165 119.759H43.4123C41.7936 119.759 40.4814 118.435 40.4814 116.803V45.1253ZM46.3432 48.082V113.846H58.2342V48.082H46.3432Z"
      fill="#297FFF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M74.2168 75.4741C74.2168 73.8482 75.529 72.5302 77.1477 72.5302H94.9004C96.5191 72.5302 97.8313 73.8482 97.8313 75.4741V116.815C97.8313 118.441 96.5191 119.759 94.9004 119.759H77.1477C75.529 119.759 74.2168 118.441 74.2168 116.815V75.4741ZM80.0786 78.418V113.871H91.9695V78.418H80.0786Z"
      fill="#297FFF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M107.951 60.2734C107.951 58.6584 109.263 57.3492 110.882 57.3492H128.635C130.253 57.3492 131.566 58.6584 131.566 60.2734V116.835C131.566 118.45 130.253 119.759 128.635 119.759H110.882C109.263 119.759 107.951 118.45 107.951 116.835V60.2734ZM113.813 63.1975V113.911H125.704V63.1975H113.813Z"
      fill="#297FFF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.06055 47.2287C5.06055 39.7895 11.1153 33.7347 18.5545 33.7347C25.9858 33.7347 32.0485 39.7387 32.0485 47.2287C32.0485 54.668 25.9938 60.7227 18.5545 60.7227C11.1153 60.7227 5.06055 54.668 5.06055 47.2287ZM18.5545 39.7321C14.4275 39.7321 11.0579 43.1017 11.0579 47.2287C11.0579 51.3558 14.4275 54.7254 18.5545 54.7254C22.6815 54.7254 26.0512 51.3558 26.0512 47.2287C26.0512 43.0668 22.6895 39.7321 18.5545 39.7321Z"
      fill="#2ED3B7"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M38.7949 13.494C38.7949 6.05473 44.8497 0 52.2889 0C59.7402 0 65.728 6.01925 65.7828 13.4719L65.7829 13.494C65.7829 20.9332 59.7281 26.988 52.2889 26.988C44.8497 26.988 38.7949 20.9332 38.7949 13.494ZM52.2889 5.99733C48.1619 5.99733 44.7922 9.36697 44.7922 13.494C44.7922 17.621 48.1619 20.9907 52.2889 20.9907C56.4123 20.9907 59.7796 17.627 59.7855 13.5049C59.7488 9.31092 56.4002 5.99733 52.2889 5.99733Z"
      fill="#2ED3B7"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M72.5303 43.8554C72.5303 36.4162 78.585 30.3615 86.0243 30.3615C93.4555 30.3615 99.5182 36.3654 99.5182 43.8554C99.5182 51.2947 93.4635 57.3494 86.0243 57.3494C78.585 57.3494 72.5303 51.2947 72.5303 43.8554ZM86.0243 36.3588C81.8972 36.3588 78.5276 39.7284 78.5276 43.8554C78.5276 47.9825 81.8972 51.3521 86.0243 51.3521C90.1513 51.3521 93.5209 47.9825 93.5209 43.8554C93.5209 39.6935 90.1593 36.3588 86.0243 36.3588Z"
      fill="#2ED3B7"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M106.265 28.6747C106.265 21.2354 112.319 15.1807 119.759 15.1807C127.198 15.1807 133.253 21.2354 133.253 28.6747C133.253 36.1139 127.198 42.1686 119.759 42.1686C112.319 42.1686 106.265 36.1139 106.265 28.6747ZM119.759 21.178C115.632 21.178 112.262 24.5476 112.262 28.6747C112.262 32.8017 115.632 36.1713 119.759 36.1713C123.886 36.1713 127.255 32.8017 127.255 28.6747C127.255 24.5476 123.886 21.178 119.759 21.178Z"
      fill="#2ED3B7"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M46.3755 21.0627C47.5249 22.1485 47.5125 23.8972 46.3476 24.9686L30.3463 39.6857C29.1814 40.7571 27.3052 40.7455 26.1558 39.6597C25.0063 38.574 25.0188 36.8252 26.1837 35.7538L42.185 21.0367C43.3498 19.9653 45.226 19.977 46.3755 21.0627Z"
      fill="#2ED3B7"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M59.8127 19.4894C60.9134 18.3133 62.7771 18.2357 63.9754 19.3161L80.0108 33.7739C81.209 34.8543 81.2881 36.6835 80.1873 37.8595C79.0866 39.0356 77.2228 39.1132 76.0246 38.0328L59.9892 23.575C58.7909 22.4946 58.7119 20.6654 59.8127 19.4894Z"
      fill="#2ED3B7"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M111.02 32.0232C111.752 33.4893 111.124 35.2554 109.617 35.9681L97.1331 41.871C95.6259 42.5837 93.8102 41.9729 93.0775 40.5069C92.3449 39.0409 92.9727 37.2747 94.4799 36.5621L106.964 30.6591C108.471 29.9465 110.287 30.5572 111.02 32.0232Z"
      fill="#2ED3B7"
    />
  </svg>
);
